<template>
  <div class="DataContent">
    <!-- <div class="functionBox">
      <el-button type="primary" size="small" @click="CollectionFun"
        >批量收藏</el-button
      >
      <el-button type="primary" size="small" @click="Download"
        >批量下载</el-button
      >
    </div> -->
    <div class="tableBox" v-if="dataListTable">
      <div class="table_box">
        <el-table
          :data="dataListTable.tableData.list"
          style="width: 100%; height: 100%"
          @selection-change="handleSelectionChange"
        >
          <!-- fixed -->
          <!--     min-width="150px" -->

          <el-table-column type="selection" width="35"></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            v-for="(item, index) in dataListTable.hearder"
            :key="index"
            :prop="item.enNames"
            :label="language == 'zh' ? item.cnNames : item.displayNames"
          >
          </el-table-column>
          <!-- <el-table-column width="100px" :label="$t('DataInfo.Operation')">
            <template slot-scope="scope">
              <div style="display: flex"> -->
                <!-- <div
                  class="btn"
                  @click="handleClick(scope.row)"
                  type="text"
                  v-log="{ params: { clickName: '下载数据' } }"
                >
                  <i class="iconfont icon-xiazai5"></i>
                </div> -->
                <!-- <div
                class="btn"
                @click="handleClick(scope.row)"
                type="text"
                v-log="{ params: { clickName: '收藏数据' } }"
              >
                <i class="iconfont icon-shoucang" style="fontSize:14px"></i>
              </div> -->
              <!-- </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <div class="footer_page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="dataListTable.tableData.pageNum"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSizes"
          :pager-count="4"
          layout="total, sizes, pager"
          :total="dataListTable.tableData.total"
        ></el-pagination>
      </div>
    </div>
    <div v-else style="text-align: center; color: #ccc; margin-top: 50px">
      {{ $t("DataHub.NoData") }}
    </div>
    <el-dialog
      title="登录提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="login_tip">
        <i class="iconfont icon-xuanzhong1"></i>
        <div class="tip">请先登录</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="toLogin()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { downloadExist, shoppingCart } from "@/axios/datashare.js";
export default {
  mixins: [mapMixin],
  mounted() {
    this.dataId = this.$route.query.dataId;
  
  },
  data() {
    return {
      dialogVisible: false,
      dataId: null,
      pageSizes: 10,
      collectionData: null,
    };
  },
  methods: {
    // 校验是否登录
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName");
    },
    handleClose() {
      this.dialogVisible = false;
    },
    toLogin() {
      this.dialogVisible = false;
      var query = this.$route.fullPath;
      this.$router.push(`/login?redirect=${query}`);
    },
    Download() {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        this.dialogVisible = true;
        return;
      }
      console.log(this.collectionData);
      if (!this.collectionData || this.collectionData.length == 0) {
        this.$message("请选择要操作的数据");
        return;
      }

      var dataIdArr = [];
      this.collectionData.forEach((item) => {
        dataIdArr.push(item.data_id);
      });
      const a = document.createElement("a"); // 创建a标签
      a.setAttribute("download", ""); // download属性
      a.setAttribute(
        "href",
        `${this.GLOBAL.url}sdg-api/share/data/batch/download?productCode=${
          this.dataId
        }&productName=${this.dataInfo.productName}&dataIds=${dataIdArr.join(
          ","
        )}`
      ); // href链接
      // productCode=${scope.row.product_code}
      a.click(); // 自执行点击事件
    },
    handleSelectionChange(obj) {
      console.log(obj);
      this.collectionData = obj;
    },
    async CollectionFun() {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        this.dialogVisible = true;
        return;
      }
      if (!this.collectionData || this.collectionData.length == 0) {
        this.$message("请选择要操作的数据");
        return;
      }

      var dataIdArr = [];
      this.collectionData.forEach((item) => {
        dataIdArr.push(item.data_id);
      });
      var param = {
        productCode: this.dataId,
        productName: this.dataInfo.productName,
        createBy: this.loginName,
        dataIds: dataIdArr.join(","),
      };
      var res = await shoppingCart(param);
      console.log(res);
      if (res.data.code == 200) {
        this.$message({
          message: "数据收藏成功!",
          type: "success",
        });
      } else {
        this.$message.error("数据收藏失败,请联系管理员！");
      }
    },
    async downloadExistFun(param) {
      return await downloadExist(param);
    },
    handleClick(obj) {
      var userVerifyLogin = this.verifyLogin();
      if (!userVerifyLogin) {
        // 提示用户登录
        this.dialogVisible = true;
        return;
      }
      var that = obj;
      var param = {
        dataId: obj.data_id,
        productCode: this.dataId,
      };
      this.downloadExistFun(param).then((res) => {
        if (res.data.code == 200) {
          const a = document.createElement("a"); // 创建a标签
          a.setAttribute("download", ""); // download属性
          a.setAttribute(
            "href",
            `${this.GLOBAL.url}sdg-api/share/data/download?dataId=${that.data_id}&productCode=${this.dataId}`
          ); // href链接
          // productCode=${scope.row.product_code}
          a.click(); // 自执行点击事件
        } else {
          this.$message({
            message: this.$t("DataHub.NotDownload"),
            // type: 'warning'
          });
          // alert("该数据为展示数据,暂不支持下载!");
        }
      });
    },
    handleSizeChange(val) {
      this.pageSizes = val;
      var param = {
        pageSizes: this.pageSizes,
        currentPage: this.dataListTable.tableData.pageNum,
      };
      bus.$emit("emitGetDataList", param);
    },
    handleCurrentChange(val) {
      var param = {
        pageSizes: this.pageSizes,
        currentPage: val,
      };
      bus.$emit("emitGetDataList", param);
    },
  },
};
</script>

<style lang="scss" >
@media screen and (min-width: 1026px) {
  .DataContent {
    margin-top: 10px;
    height: 100%;
    .login_tip {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      i {
        font-size: 40px;
        color: rgba(248, 187, 134, 1);
        font-weight: 600;
        margin-bottom: 10px;
      }
      .tip {
        font-weight: 600;
        font-size: 22px;
      }
    }
    .functionBox {
      margin: 0 0 10px 10px;
    }
    .el-table__body-wrapper {
      // background: #fff;
      // height: calc(100vh - 0px);
    }
    .el-table th {
      background: #d8d8d8;
    }
    .tableBox {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: space-between;
      .footer_page {
        margin-top: 30px;
        height: 80px;
      }
      .table_box {
        width: 100%;
        // flex: 1;
      }
    }
    .el-table__fixed-right {
      // box-shadow: none !important
    }
    .el-table th,
    .el-table tr {
      background: rgba(244, 244, 244, 1) !important;
    }
    .el-table th > .cell:first-child {
      padding-left: 10px;
      padding-right: 0px;
    }
    .el-table thead tr {
      // background: #333 !important;
      color: #000;
    }
    .el-checkbox__inner {
      width: 20px;
      height: 20px;
      // overflow: hidden;
    }
    .el-checkbox__inner::after {
      height: 9px;
      width: 6px;
      left: 5px;
    }

    // background: rgba(189,189,189,1)
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border: 1px solid #dcdfe6;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      border: 1px solid #dcdfe6;
      background: rgba(189, 189, 189, 1);
    }
    .el-table .cell {
      overflow: none;
      word-break: inherit !important;
    }
    .el-table__row td {
      background: #fff;
    }
    // .el-table__row td:nth-of-type(odd) {
    //   background: rgba(255, 196, 10, 1);
    //   color: #fff;
    // }
    // .el-table__row td:nth-of-type(even) {
    //   background: rgba(1, 160, 132, 1);
    //   color: #fff;
    // }
    // .el-table__row:nth-of-type(odd) {
    //   td:nth-of-type(1) {
    //     background: rgb(255, 255, 255);
    //   }
    // }
    // .el-table__row:nth-of-type(even) {
    //   td:nth-of-type(1) {
    //     background: rgb(244, 244, 244);
    //   }
    // }
    .btn {
      cursor: pointer;
      font-size: 12px;
      color: #333;
    }
    .el-table__body-wrapper::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 12px;
      border-radius: 4px;
      scrollbar-arrow-color: red;
      cursor: pointer;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      /* border-radius: 5px; */
      // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: #ccc;
      border-radius: 4px;
      scrollbar-arrow-color: red;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background: #f8f8f8;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .DataContent {
    margin-top: 20px;
    height: 100%;
    .el-table__body-wrapper {
      background: #fff;
      height: calc(100vh - 0px);
    }
    .tableBox {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .footer_page {
        margin-top: 30px;
        height: 80px;
      }
      .table_box {
        width: 100%;
        flex: 1;
      }
    }
    .el-table__fixed-right {
      // box-shadow: none !important
    }
    .el-table th,
    .el-table tr {
      background: rgba(244, 244, 244, 1) !important;
    }
    .el-table thead tr {
      // background: #333 !important;
      color: #000;
    }
    .el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
    .el-checkbox__inner::after {
      height: 9px;
      width: 6px;
      left: 5px;
    }

    // background: rgba(189,189,189,1)
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border: 1px solid #dcdfe6;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      border: 1px solid #dcdfe6;
      background: rgba(189, 189, 189, 1);
    }
    .el-table .cell {
      overflow: none;
    }
    .el-table__row td:nth-of-type(odd) {
      background: rgba(255, 196, 10, 1);
      color: #fff;
    }
    .el-table__row td:nth-of-type(even) {
      background: rgba(1, 160, 132, 1);
      color: #fff;
    }
    .el-table__row:nth-of-type(odd) {
      td:nth-of-type(1) {
        background: rgb(255, 255, 255);
      }
    }
    .el-table__row:nth-of-type(even) {
      td:nth-of-type(1) {
        background: rgb(244, 244, 244);
      }
    }
    .btn {
      cursor: pointer;
      font-size: 16px;
      color: #fff;
    }
    .el-table__body-wrapper::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 12px;
      border-radius: 4px;
      scrollbar-arrow-color: red;
      cursor: pointer;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      /* border-radius: 5px; */
      // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: #ccc;
      border-radius: 4px;
      scrollbar-arrow-color: red;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background: #f8f8f8;
    }
  }
}
@media screen and (max-width: 767px) {
  .DataContent {
    height: 100%;
    .el-table__body-wrapper {
      background: #fff;
      min-height: 300px;
      // height: calc(100vh - 0px);
    }
    .tableBox {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .footer_page {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
      }
      .table_box {
        width: 100%;
        flex: 1;
      }
    }
    .el-table__fixed-right {
      // box-shadow: none !important
    }
    .el-table th,
    .el-table tr {
      background: rgba(244, 244, 244, 1) !important;
    }
    .el-table thead tr {
      // background: #333 !important;
      color: #000;
    }
    .el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
    .el-checkbox__inner::after {
      height: 9px;
      width: 6px;
      left: 5px;
    }

    // background: rgba(189,189,189,1)
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border: 1px solid #dcdfe6;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      border: 1px solid #dcdfe6;
      background: rgba(189, 189, 189, 1);
    }
    .el-table__row:hover {
      background: none !important;
    }
    .el-table .cell {
      overflow: none;
    }
    .el-table__row td:nth-of-type(odd) {
      background: rgba(255, 196, 10, 1);
      color: #fff;
    }
    .el-table__row td:nth-of-type(even) {
      background: rgba(1, 160, 132, 1);
      color: #fff;
    }
    .el-table__row:nth-of-type(odd) {
      td:nth-of-type(1) {
        background: rgb(255, 255, 255);
      }
    }
    .el-table__row:nth-of-type(even) {
      td:nth-of-type(1) {
        background: rgb(244, 244, 244);
      }
    }
    .btn {
      cursor: pointer;
      font-size: 16px;
      color: #fff;
    }
    .el-table__body-wrapper::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 12px;
      border-radius: 4px;
      scrollbar-arrow-color: red;
      cursor: pointer;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      /* border-radius: 5px; */
      // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: #ccc;
      border-radius: 4px;
      scrollbar-arrow-color: red;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background: #f8f8f8;
    }
  }
}
</style>